import React from "react";
import { ArrowRightOutlined } from "@ant-design/icons";
import { solutionsContent } from "../../data/homeContent";
import { useNavigate } from "react-router-dom";

const SolutionCard = ({
  icon: Icon,
  iconBg,
  title,
  description,
  features,
  cardBg,
  setkey,
}) => {
  const navigate = useNavigate();
  console.log("Solution Card Key: ", setkey);

  return (
    <div
      className={`rounded-2xl p-8 transition-transform duration-300 hover:-translate-y-2 ${cardBg}`}
    >
      <div
        className={`w-16 h-16 flex items-center justify-center rounded-full mb-6 shadow-lg ${iconBg}`}
      >
        <Icon className="text-3xl text-white" />
      </div>
      <h3 className="text-2xl font-extrabold mb-3 text-gray-900">{title}</h3>
      <p className="text-gray-700 mb-6">{description}</p>
      <ul className="space-y-3 mb-6">
        {features.map((feature, idx) => (
          <li key={idx} className="flex items-center text-gray-800">
            <span className="w-3 h-3 bg-gradient-to-tr from-blue-400 to-purple-400 rounded-full mr-3 shadow" />
            {feature}
          </li>
        ))}
      </ul>
      <button
        onClick={() => {
          // Check against the 'id' prop
          if (setkey === "restaurant-suite") {
            navigate("/hospitality");
          } else {
            navigate("/retail");
          }
        }}
        className="inline-flex items-center px-6 py-2 rounded-full font-semibold bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow hover:scale-105 transition"
      >
        Learn More <ArrowRightOutlined className="ml-2" />
      </button>
    </div>
  );
};

const Solutions = () => {
  const { title, subtitle, solutions } = solutionsContent;
  return (
    <div className="py-24 bg-gradient-to-br from-blue-50 via-white to-pink-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-extrabold text-center mb-3 bg-gradient-to-r from-blue-600 to-pink-500 text-transparent bg-clip-text">
          {title}
        </h2>
        <p className="text-xl text-gray-600 text-center mb-12">{subtitle}</p>
        <div className="grid md:grid-cols-2 gap-10">
          {solutions.map(
            (sol, idx) => (
              (<SolutionCard key={idx} {...sol} setkey={sol.key} />)
            ),
          )}
        </div>
      </div>
    </div>
  );
};

export default Solutions;
